/**
 * Client-side heuristic deciding whether pasted/entered canvas text should trigger the
 * paste-a-question AI action popover (spec 044 FR-006). Per spec Assumptions, this does
 * NOT need to be a precise question classifier — a permissive trigger is acceptable since
 * dismissing the popover has no effect on the canvas (US2 Acceptance Scenario 5).
 */

const MIN_LENGTH_THRESHOLD = 15;

const PROBLEM_KEYWORDS =
  /\b(solve|calculate|find|prove|explain|evaluate|determine|simplify|derive|what is|what are|how many|how much|why does|why is)\b/i;

export function isLikelyQuestionOrProblem(text: string): boolean {
  const trimmed = text.trim();
  if (trimmed.length === 0) {
    return false;
  }
  if (trimmed.endsWith('?')) {
    return true;
  }
  if (PROBLEM_KEYWORDS.test(trimmed)) {
    return true;
  }
  return trimmed.length >= MIN_LENGTH_THRESHOLD;
}
